import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Public\InquiryController::store
* @see app/Http/Controllers/Public/InquiryController.php:18
* @route 'https://mktcode.digital/inquiry'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://mktcode.digital/inquiry',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Public\InquiryController::store
* @see app/Http/Controllers/Public/InquiryController.php:18
* @route 'https://mktcode.digital/inquiry'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\InquiryController::store
* @see app/Http/Controllers/Public/InquiryController.php:18
* @route 'https://mktcode.digital/inquiry'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Public\InquiryController::store
* @see app/Http/Controllers/Public/InquiryController.php:18
* @route 'https://mktcode.digital/inquiry'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Public\InquiryController::store
* @see app/Http/Controllers/Public/InquiryController.php:18
* @route 'https://mktcode.digital/inquiry'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const inquiry = {
    store: Object.assign(store, store),
}

export default inquiry